<template>
  <div>
    <div class="row pt-3">
      <div class="col-md-12">
        <div class="filter-container">
          <ValidationObserver
            ref="formValidator"
            v-slot="{}"
            tag="form"
            class="row pl-3 pr-1"
          >
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-3 py-1">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Servicio"
                    rules="required"
                  >
                    <custom-drop-down
                      v-model="Filter.Service"
                      :options="Services"
                      placeholder="Seleccione el Servicio"
                      required
                      :fieldkey="'id'"
                      :fieldname="'name'"
                      :error="errors[0]"
                      :custom-error-msg="errorMessage.service"
                    />
                  </ValidationProvider>
                </div>
                <div class="col-md-7 py-1">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Pei"
                    rules="required"
                  >
                    <custom-input
                      v-model="Filter.Pei"
                      placeholder="Escriba Número de PEI"
                      left-icon
                      :mask-type="'AppointmentNumber'"
                      icon="fa fa-search orange-icon"
                      :error="errors[0]"
                      :custom-error-msg.sync="errorMessage.pei"
                    />
                  </ValidationProvider>
                </div>
                <div class="col-md-2 py-1">
                  <action-button
                    text="Buscar"
                    variant="success"
                    class="fr px-4"
                    @click="getModifyMileageServices"
                  />
                </div>
              </div>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
    <div class="row pt-3">
      <div class="col-12">
        <custom-separator text="Modificar Millaje" />
      </div>
    </div>
    <ValidationObserver ref="formValidatorRow" v-slot="{}" tag="form" class="">
      <div v-if="model.length > 0" class="row pt-2">
        <div class="col-12">
          <custom-callout class="mt-2">
            <div class="row">
              <div class="col-12 pl-5">
                <div class="divider-horizontal">
                  <div v-for="(item, index) in model" :key="index" class="row">
                    <div v-if="showServiceColumn" class="col-4 pt-0">
                      <div class="regular">
                        Nombre del Servicio:
                      </div>
                      <div class="regular text-black">
                        <h5>{{ item.peiAnalysisService }}</h5>
                      </div>
                    </div>
                    <div class="col-3 pt-0">
                      <div class="regular">
                        Millaje Actual:
                      </div>
                      <div class="regular text-black">
                        <h5>{{ item.mileage }}</h5>
                      </div>
                    </div>
                    <div class="col-3 pt-0">
                      <div class="regular">
                        Millaje Corregido:
                      </div>
                      <div class="regular text-black">
                        <ValidationProvider name="Millaje Corregido">
                          <custom-input
                            v-model="item.newMileage"
                            :error="item.mileageValidationMessages"
                            :custom-error-msg="item.mileageValidationMessages"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </custom-callout>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import CustomInput from '@/components/common/CustomInput';
import ActionButton from '@/components/common/ActionButton';
import CustomSeparator from '@/components/common/CustomSeparator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CustomDropDown from '@/components/common/CustomDropDown';
import mixWait from '@/mixin/loading.mixin';
import mixAlert from '@/mixin/alert.mixin';
import CustomCallout from '@/components/common/CustomCallout';
import peiAnalysisServices from '@/utils/constants/pei/peiAnalysisService.js';

export default {
  name: 'ModifyMileageServices',
  mixins: [mixAlert, mixWait],
  components: {
    CustomInput,
    ActionButton,
    CustomSeparator,
    CustomDropDown,
    ValidationObserver,
    ValidationProvider,
    CustomCallout,
  },
  data() {
    return {
      advance: false,
      Filter: {
        Pei: null,
        Service: null,
      },
      Services: [],
      validationMessages: [],
      errorMessage: {
        pei: '',
        service: '',
        mileage: '',
      },
      mileageValidationMessages: null,
      model: [],
      showServiceColumn: false,
    };
  },
  methods: {
    loadServices() {
      let self = this;
      self
        .$ApiGet(
          `api/code/getcodedisciplinetypes?serviceTypeId=3&ValidForFlag=Pei`
        )
        .then((response) => {
          self.Services = response.data;
        });
    },
    loadValidationMessages() {
      const messageCodes = ['22130', '22131', '21080', 'R03200148', '0636'];
      const promise = this.$ApiGet(
        '/api/validationsmessages?messageCodes=' +
          messageCodes.join('&messageCodes=')
      );
      promise.then((res) => {
        this.validationMessages = res.data;
        this.errorMessage.pei = this.getMessage('22131').name.replace(
          '{0}',
          'PEI'
        );
        this.errorMessage.service = this.getMessage('22130').name;
        this.errorMessage.mileage = this.getMessage('21080').name;
      });
    },
    getMessage(code) {
      const message = this.validationMessages.find(
        (element) => element.id == code
      );
      return message;
    },
    async LoadAlls() {
      let self = this;
      await self.loadServices();
    },
    getAnalysisService() {
      this.$ApiGet(
        `/api/pei/${this.Filter.Pei}/mileage/${this.Filter.Service.id}`
      )
        .then((res) => {
          this.model = res.data;
          this.model = this.model.map((obj) => ({
            ...obj,
            newMileage: '',
            mileageValidationMessages: null,
          }));
          this.showServiceColumn =
            this.Filter.Service.id == peiAnalysisServices.Otros ? true : false;
          this.$emit('onChange');
        })
        .catch((err) => {
          this.response = err;
        });
    },
    async onSave() {
      this.model.forEach((item) => {
        if (!item.newMileage) {
          item.mileageValidationMessages = 'El millaje es requerido.';
          return;
        }

        if (item.newMileage <= 0) {
          item.mileageValidationMessages =
            'El valor de millaje no puede ser 0.';
          return;
        }

        if (item.newMileage) {
          this.$ApiPut(
            `api/pei/${this.Filter.Pei}/analysisservice/${item.peiAnalysisServiceId}/mileage/${item.newMileage}`
          )
            .then(() => {
              this.getAnalysisService();
              this.ShowToast(
                'Proceso exitoso.',
                'Los datos fueron guardados exitosamente.',
                'success'
              );
            })
            .catch((err) => {
              this.response = err;
            });
        }
      });
    },
    async validate() {
      return await this.$refs.formValidator.validate();
    },
    async getModifyMileageServices() {
      const isValid = await this.validate();
      if (!isValid) {
        this.ShowToast('Error', this.getMessage('R03200148').name, 'error');
        return;
      }

      this.getAnalysisService();
    },
  },
  async created() {
    await this.loadValidationMessages();
  },
  mounted() {
    this.LoadAlls();
  },
};
</script>

<style scoped>
.filter-container {
  background-color: #f4f6f3;
  padding: 15px;
}
.separator {
  display: flex;
  align-items: center;
  text-align: center;
  color: #aab7b1;
  font: 900 14px/17px Lato;
}
.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #aab7b1;
}
.separator::before {
  margin-right: 0.5em;
}
.separator::after {
  margin-left: 0.5em;
}
.text-black {
  color: #11291b;
}
</style>
